<template>
	<h1>Estadisticas</h1>
</template>
<script>
	export default {
		mounted() {
			this.carritoConsultarCantidad()
			this.obtenerNotificaciones()
		}
	}
</script>
<style lang="stylus"></style>